var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.shown)?_c('div',{staticClass:"search-overlay",class:{ visible: _vm.visible },on:{"click":function($event){$event.stopPropagation();return _vm.close.apply(null, arguments)}}},[_c('Searchbar',{attrs:{"auto-focus":true},on:{"select":_vm.close}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }